import {Component} from "@angular/core";
import {ContactSearchModel} from "../contact-search.model";
import {ContactEntityModel} from "../contact-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../framework/entity/search/search-page/abstract-search-page";
import {ContactSearchData} from "../contact-search.data";

@Component({
    selector: "wbo-contact-search-page",
    templateUrl: "./contact-search-page.component.html",
    providers: [provideSearchModel(ContactSearchModel), provideEntityModel(ContactEntityModel)]
})
export class ContactSearchPageComponent extends AbstractSearchPage {

    canDelete(contact: ContactSearchData): boolean {
        return !contact.integratedLoyaltyId;
    }
}
